module.exports = __webpack_public_path__ + "static/media/019_A - 3 - SIGN IN text.39bc512e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/kp/019_A - 3 - SIGN IN text.png
// module id = 517
// module chunks = 0